import { z } from 'zod/v4';

/**
 * Parametry wyszukiwania ekranu szczegółów — uczestnika, klienta i rezerwacji.
 *
 * Zakładki żyją w ścieżce (patrz `detailsTabs.ts`), a w adresie zostaje to,
 * co dotyczy całego ekranu niezależnie od zakładki — tryb podglądu i edycji.
 * Dzięki temu odświeżenie strony i link wysłany współpracownikowi trafiają w to
 * samo miejsce, a powrót z przepływu wprowadzania paczki wraca do trybu edycji.
 */

/**
 * Tryb ekranu. Wejście w `EDIT` tworzy szkic, jeśli jeszcze nie istnieje;
 * wyjście prowadzi wyłącznie przez modal — patrz `ExitEditingChoice`.
 */
export enum DetailsMode {
  VIEW = 'view',
  EDIT = 'edit',
}

/**
 * Schemat ekranów uczestnika, zapisującego i rezerwacji. Siedzi na route'cie
 * **nadrzędnym**, a route'y zakładek go dziedziczą — tryb edycji dotyczy całego
 * ekranu, więc przełączenie zakładki nie ma prawa go zgubić.
 */
export const detailsSearchSchema = z.object({
  mode: z
    .enum(DetailsMode)
    .catch(DetailsMode.VIEW)
    .optional()
    .default(DetailsMode.VIEW),
});

export type DetailsSearch = z.infer<typeof detailsSearchSchema>;
